import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-rito-fornero-view',
  templateUrl: './form-rito-fornero-view.component.html',
  styleUrls: ['./form-rito-fornero-view.component.css']
})
export class FormRitoForneroViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
